import tw, { styled } from 'twin.macro';
export const StyledLogo = styled.div`
  ${tw`relative`};
  ${tw`max-w-[180px] h-[72px]`};
`;

export const StyledLogoImage = styled.div<{ isVisible: boolean }>`
  ${tw`absolute`};
  ${tw`top-0 left-0`};
  ${tw`transition-opacity duration-1000`}
  ${({ isVisible }) => (isVisible ? tw`opacity-100 delay-1000` : tw`opacity-0`)};
`;
